<template>
    <nav aria-label="breadcrumb">
        <ol class="breadcrumb">
            <li class="breadcrumb-item">
                <a :href=route_back>Список клиентов</a>
            </li>
            <li class="breadcrumb-item active" aria-current="page">Добавить клиента</li>
        </ol>
    </nav>

    <div class="form-narrow">
        <div class="mb-4">
            <div class="form-label">
                Имя пользователя
                <span class="color-red">*</span>
            </div>
            <input type="text" class="form-control" id="client-name" v-model="formData.name" placeholder="Введите имя пользователя">
        </div>

        <div class="mb-4">
            <div class="form-label">
                Путь
                <span class="color-red">*</span>
            </div>
            <input type="text" class="form-control" id="client-url" v-model="formData.url" placeholder="ds-url">
        </div>

        <div class="mb-4">
            <div class="form-label">Комментарий</div>
            <textarea class="form-control mb-2" id="client-comment" rows="3" v-model="formData.comment"></textarea>
        </div>
    </div>

    <div class="d-flex w-50 align-items-center justify-content-start">
        <ConfirmBtn :class="'btn btn-lg btn-primary me-3'" :text="'Сохранить'" @btnClick="createClient"/>
        <a class="btn btn-lg btn-outline-dark" :href="route_back">Отменить</a>
    </div>

    <Alert />
</template>

<script>
import ConfirmBtn from "../../../../elements/ConfirmBtn.vue";
import Client from "../../../../models/Client";
import Alert from "../../../alerts/Alert.vue";
import { mapMutations } from "vuex/dist/vuex.cjs.js";

export default {
    name: "ClientCreateComponent",
    components: { Alert, ConfirmBtn },
    props: {
        route_back: String,
        route_create: String
    },
    data: function () {
       return {
           client: new Client({
               route_create: this.route_create
           }),
           formData: {
               name: '',
               comment: '',
               auto_create_license: '',
               url: '',
           },
       }
    },
    methods: {
        ...mapMutations('alerts', ['addAlert']),
        ...mapMutations('ui', ['toggleLoading']),
        createClient: async function () {
            if (this.formData.name == '') {
                this.addAlert({ type: 'warning', title: 'Предупреждение', text: 'Введите имя пользователя!' });
                this.toggleLoading();
                return;
            }

            if (this.formData.url == '') {
                this.addAlert({ type: 'warning', title: 'Предупреждение', text: 'Введите путь!' });
                this.toggleLoading();
                return;
            }

            let result = await this.client.create(this.formData);
            if(result)
            {
                window.location.href = this.route_back;
            }
            else
            {
                console.log('error: create_client');
                this.toggleLoading();
            }
        },
    }
}
</script>

<style scoped>

</style>
